﻿import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'capitalize' })
export class CapitalizePipe implements PipeTransform {
    transform(input: string): string {
        if (!input)
            return '';
        return input.charAt(0).toUpperCase() + (input.length > 1 ? input.substr(1).toLowerCase() : '');
    }
}
